document.addEventListener('DOMContentLoaded', function() {
    const popup = document.querySelector('.homepage-popup');
    const backdrop = document.querySelector('.homepage-popup__backdrop');
    const closeButton = document.querySelector('.close-popup');

    if (!popup || !backdrop) {
        return;
    }

    function dismissPopup() {
        popup.classList.remove('active');
        backdrop.classList.remove('active');
        document.cookie = 'popup_shown=true; path=/; max-age=31536000;';
    }

    closeButton?.addEventListener('click', dismissPopup);
    backdrop.addEventListener('click', dismissPopup);

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && popup.classList.contains('active')) {
            dismissPopup();
        }
    });

    const donateButton = document.querySelector('.homepage-popup__button a');
    donateButton?.addEventListener('click', function() {
        document.cookie = 'popup_shown=true; path=/; max-age=31536000;';
    });

    const popupShown = document.cookie.split('; ').find(row => row.startsWith('popup_shown='));
    if (!popupShown) {
        popup.classList.add('active');
        backdrop.classList.add('active');
    }
});
